import demoGif from "../assets/demo_tuto.gif";

export function EditorShowcase() {
  return (
    <section className="showcase">
        <div className="showcase-content">
            <h2>The Split-screen experience</h2>
            <p>From raw LaTeX to beautiful mathematics instantly. Focus on your ideas while we handle the formatting.</p>
        </div>
        <div className="showcase-visual">
            <div className="showcase-image">
                <img src={demoGif} alt="CoffeeLaTek Demo" />
            </div>
        </div>
    </section>
  );
}
